export default "__VITE_ASSET__BEMn9RA___"